import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CopyrightIcon from '@material-ui/icons/Copyright';
import CancelIcon from '@material-ui/icons/Cancel';

import "./Guide.scss";

interface Props {
    close():void,
}

const Guide = (props:Props)=> {
    return (
        <div id="guide" className="modalRoot">
            <Typography variant="subtitle1" className="subtitle1">よるのおてがみ？</Typography>
            <div className="section">
                誰かの書いたおてがみを読んだり、自分の書いたおてがみを読ませたり。
            </div>
            <Typography variant="subtitle1" className="subtitle1">著作権等</Typography>
            <div className="section">
                おてがみの著作権は書いたプレイヤーのものですが、レトロインクはプレイヤーが書いたおてがみをこのゲームおよび派生する関連コンテンツ内において自由に使用する権利を有します。<br/>
            </div>
            <div className="credit">
                <span className="withIcon"><CopyrightIcon/>レトロインク　2019</span><br/>
            </div>
            <IconButton aria-label="close" onClick={props.close} color="primary" style={{position:"absolute",top:"-0.3em",right:"-0.3em"}}>
                <CancelIcon/>
            </IconButton>
        </div>
    );
}

export default Guide;
